<template>
  <header class="landing-header">
    <!-- Drawer izquierdo mobile: teléfono y accesos -->
    <div
      class="mobile-left-overlay"
      :class="{ show: isLeftMenuOpen }"
      aria-hidden="true"
      @click="closeLeftMenu"
    />
    <div class="mobile-left-drawer" :class="{ show: isLeftMenuOpen }">
      <div class="mobile-left-drawer-header">
        <button type="button" class="mobile-left-drawer-close" aria-label="Cerrar" @click="closeLeftMenu">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="mobile-left-drawer-body">
        <a href="tel:+12148889000" class="mobile-left-drawer-item mobile-left-drawer-phone">
          <i class="fas fa-phone-alt"></i>
          <span>(214) 888-9000</span>
        </a>
        <router-link to="/member-dashboard" class="mobile-left-drawer-item" @click.native="closeLeftMenu">
          Acceso a Miembros
        </router-link>
        <router-link to="/insurance-agent/dashboard" class="mobile-left-drawer-item" @click.native="closeLeftMenu">
          Acceso a Agentes
        </router-link>
        <a
          href="/providers#form-section"
          class="mobile-left-drawer-item"
          @click.prevent="onProvidersClick(closeLeftMenu)"
        >
          Registro de Agentes
        </a>
      </div>
    </div>

    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container">
        <!-- Desktop: logo a la izquierda -->
        <router-link to="/" class="navbar-brand navbar-brand-desktop">
          <div class="brand-content">
            <img :src="logoImage" alt="Hispano Medical Plan" class="logo-img" />
          </div>
        </router-link>

        <!-- Mobile: botón menú izquierdo (teléfono y accesos) -->
        <button
          type="button"
          class="mobile-left-menu-btn"
          aria-label="Menú teléfono y accesos"
          @click="toggleLeftMenu"
        >
          <i class="fas fa-bars"></i>
        </button>

        <!-- Mobile: logo centrado -->
        <router-link to="/" class="navbar-brand navbar-brand-mobile">
          <div class="brand-content">
            <img :src="logoImage" alt="Hispano Medical Plan" class="logo-img" />
          </div>
        </router-link>
        
        <button 
          class="navbar-toggler" 
          type="button" 
          aria-controls="navbarNav" 
          :aria-expanded="isMobileMenuOpen"
          aria-label="Toggle navigation"
          @click="toggleMobileMenu"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        
        <div 
          class="collapse navbar-collapse" 
          :class="{ show: isMobileMenuOpen }" 
          id="navbarNav"
        >
          <ul class="navbar-nav mx-auto">
            <li class="nav-item">
              <router-link to="/plans" class="nav-link" @click.native="closeMobileMenu">Planes</router-link>
            </li>
            <li class="nav-item">
              <a
                href="/providers#form-section"
                class="nav-link"
                @click.prevent="onProvidersClick(closeMobileMenu)"
              >Proveedores</a>
            </li>
            <li class="nav-item">
              <router-link to="/contact" class="nav-link" @click.native="closeMobileMenu">Contacto</router-link>
            </li>
            <li class="nav-item dropdown" :class="{ show: isBenefitsDropdownOpen }">
              <a 
                class="nav-link dropdown-toggle" 
                href="#" 
                id="benefitsDropdown" 
                role="button" 
                @click.prevent="toggleBenefitsDropdown"
                aria-haspopup="true" 
                :aria-expanded="isBenefitsDropdownOpen"
              >
                Beneficios
              </a>
              <div 
                class="dropdown-menu" 
                :class="{ show: isBenefitsDropdownOpen }"
                aria-labelledby="benefitsDropdown"
                @click="closeBenefitsDropdown"
              >
                <router-link to="/patientflow" class="dropdown-item" @click.native="closeMobileMenu">PatientFlow</router-link>
                <router-link to="/detalles-del-plan" class="dropdown-item" @click.native="closeMobileMenu">Detalles del plan</router-link>
                <router-link to="/laboratorios" class="dropdown-item" @click.native="closeMobileMenu">Laboratorios</router-link>
                <router-link to="/telemedicina" class="dropdown-item" @click.native="closeMobileMenu">Telemedicina</router-link>
              </div>
            </li>
            <li class="nav-item">
              <router-link to="/member-dashboard" class="nav-link" @click.native="closeMobileMenu">Miembros</router-link>
            </li>
          </ul>
          
          <div class="navbar-actions">
            <div class="language-selector">
              <img src="/media/svg/flags/226-united-states.svg" alt="English" class="flag-icon" />
              <img src="/media/svg/flags/252-mexico.svg" alt="Español" class="flag-icon" />
            </div>
            <router-link to="/plans" class="btn btn-member" @click.native="closeMobileMenu">
              <i class="fas fa-users mr-2"></i>
              Hazte Miembro
            </router-link>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import scrollToProvidersForm from '@/view/pages/landings/mixins/scrollToProvidersForm'

export default {
  name: "LandingHeader",
  mixins: [scrollToProvidersForm],
  data() {
    return {
      logoImage: require('@/assets/lp/hmp/hmp-logo-color.png'),
      isBenefitsDropdownOpen: false,
      isMobileMenuOpen: false,
      isLeftMenuOpen: false
    };
  },
  mounted() {
    // Cerrar dropdown al hacer clic fuera
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    document.body.classList.remove('mobile-menu-open');
  },
  methods: {
    onProvidersClick(closeFn) {
      if (typeof closeFn === 'function') closeFn()
      this.goToProvidersForm()
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      document.body.classList.toggle('mobile-menu-open', this.isMobileMenuOpen);
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
      document.body.classList.remove('mobile-menu-open');
    },
    toggleLeftMenu() {
      this.isLeftMenuOpen = !this.isLeftMenuOpen;
    },
    closeLeftMenu() {
      this.isLeftMenuOpen = false;
    },
    toggleBenefitsDropdown() {
      this.isBenefitsDropdownOpen = !this.isBenefitsDropdownOpen;
    },
    closeBenefitsDropdown() {
      this.isBenefitsDropdownOpen = false;
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector('.dropdown');
      if (dropdown && !dropdown.contains(event.target)) {
        this.isBenefitsDropdownOpen = false;
      }
      const navbar = this.$el.querySelector('.navbar');
      if (navbar && !navbar.contains(event.target)) {
        this.closeMobileMenu();
      }
      const leftDrawer = this.$el.querySelector('.mobile-left-drawer');
      const leftBtn = this.$el.querySelector('.mobile-left-menu-btn');
      if (leftDrawer && !leftDrawer.contains(event.target) && leftBtn && !leftBtn.contains(event.target)) {
        this.closeLeftMenu();
      }
    }
  },
  watch: {
    $route() {
      this.closeMobileMenu();
      this.closeLeftMenu();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../pages/landings/styles/variables';

.landing-header {
  background: $landing-bg-white;
  box-shadow: 0 2px 10px $landing-primary-rgba-10;
  position: sticky;
  top: 46px;
  z-index: 1000;

  .navbar-brand-mobile {
    display: none;
  }

  .mobile-left-menu-btn {
    display: none;
  }
  
  .navbar {
    padding: 1.5rem 0;
    
    .navbar-brand {
      text-decoration: none;
      
      .brand-content {
        display: flex;
        align-items: center;
        
        .logo-img {
          height: 52px;
          width: auto;
          max-width: min(220px, 48vw);
          object-fit: contain;
          transition: transform 0.3s ease;
          
          &:hover {
            transform: scale(1.05);
          }
        }
      }
    }
    
    .navbar-nav {
        .nav-link {
          color: $landing-text-dark;
          font-weight: 600;
          padding: 0.85rem 1.5rem;
          transition: all 0.3s ease;
          font-size: 1.3rem;
          letter-spacing: 0.2px;
        
          &:hover {
            color: $landing-primary-color;
            transform: translateY(-2px);
          }
        }
        
        .dropdown {
          position: relative;
          
          .dropdown-toggle {
            cursor: pointer;
            
            &::after {
              margin-left: 0.5rem;
              transition: transform 0.3s ease;
            }
          }
          
          &.show {
            .dropdown-toggle::after {
              transform: rotate(180deg);
            }
            
            .dropdown-menu {
              display: block;
            }
          }
          
          .dropdown-menu {
            display: none;
            position: absolute;
            top: 100%;
            left: 0;
            z-index: 1000;
            border: none;
            box-shadow: 0 4px 15px $landing-primary-rgba-15;
            border-radius: 8px;
            margin-top: 0.5rem;
            padding: 0.5rem 0;
            min-width: 220px;
            background: $landing-bg-white;
            
            &.show {
              display: block;
            }
            
            .dropdown-item {
              color: $landing-text-dark;
              font-weight: 500;
              padding: 0.85rem 1.75rem;
              transition: all 0.3s ease;
              font-size: 1.15rem;
              display: block;
              text-decoration: none;
              
              &:hover {
                background-color: $landing-bg-light;
                color: $landing-primary-color;
                text-decoration: none;
                transform: translateX(5px);
              }
              
              &.router-link-active {
                background-color: $landing-primary-rgba-10;
                color: $landing-primary-color;
                font-weight: 600;
              }
            }
          }
        }
    }
    
    .navbar-actions {
      display: flex;
      align-items: center;
      gap: 20px;
      
      .language-selector {
        display: flex;
        gap: 12px;
        
        .flag-icon {
          width: 32px;
          height: 24px;
          cursor: pointer;
          border-radius: 3px;
          transition: transform 0.2s ease;
          
          &:hover {
            transform: scale(1.15);
          }
        }
      }
      
      .btn-member {
        background: $landing-primary-gradient;
        color: white;
        border: none;
        border-radius: 30px;
        padding: 16px 32px;
        font-weight: 700;
        font-size: 1.3rem;
        text-decoration: none;
        display: flex;
        align-items: center;
        transition: all 0.3s ease;
        box-shadow: 0 6px 20px $landing-primary-rgba-35;
        letter-spacing: 0.3px;
        
        &:hover {
          background: $landing-primary-gradient-dark;
          transform: translateY(-3px);
          box-shadow: 0 8px 25px $landing-primary-rgba-45;
          color: white;
          text-decoration: none;
        }
        
        i {
          font-size: 1.3rem;
          margin-right: 8px;
        }
      }
    }
  }
  
  @media (max-width: 991px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1001;
    top: 0;

    .navbar-brand-desktop {
      display: none !important;
    }

    .navbar-brand-mobile {
      display: flex !important;
      flex: 1;
      justify-content: center;
      margin: 0;
      padding: 0;
    }

    .mobile-left-menu-btn {
      display: flex !important;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      padding: 0;
      border: none;
      background: transparent;
      color: $landing-text-dark;
      font-size: 1.4rem;
      cursor: pointer;
      border-radius: 8px;
      flex-shrink: 0;
      -webkit-tap-highlight-color: transparent;

      &:hover {
        background: $landing-bg-light;
        color: $landing-primary-color;
      }
    }

    .navbar .container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      max-width: 100%;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }

    .navbar-toggler {
      flex-shrink: 0;
    }

    .navbar {
      position: relative;
      padding: 0.75rem 0;
    }
  }

  .mobile-left-overlay {
    display: none;
  }

  .mobile-left-drawer {
    display: none;
  }

  @media (max-width: 991px) {
    .mobile-left-overlay {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.4);
      z-index: 1002;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.3s ease;
    }

    .mobile-left-overlay.show {
      display: block;
      opacity: 1;
      pointer-events: auto;
    }

    .mobile-left-drawer {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      width: 280px;
      max-width: 85vw;
      height: 100vh;
      background: $landing-bg-white;
      box-shadow: 4px 0 20px $landing-primary-rgba-15;
      z-index: 1003;
      transform: translateX(-100%);
      transition: transform 0.3s ease;
      overflow-y: auto;
    }

    .mobile-left-drawer.show {
      transform: translateX(0);
    }

    .mobile-left-drawer-header {
      padding: 1rem 1.25rem;
      border-bottom: 1px solid $landing-border-light;
      display: flex;
      justify-content: flex-end;
    }

    .mobile-left-drawer-close {
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background: transparent;
      color: $landing-text-dark;
      font-size: 1.25rem;
      cursor: pointer;
      border-radius: 8px;

      &:hover {
        background: $landing-bg-light;
        color: $landing-primary-color;
      }
    }

    .mobile-left-drawer-body {
      padding: 1rem 0;
    }

    .mobile-left-drawer-item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 1rem 1.25rem;
      color: $landing-text-dark;
      text-decoration: none;
      font-weight: 600;
      font-size: 1.1rem;
      transition: background 0.2s ease;
      border: none;
      background: none;
      width: 100%;
      text-align: left;
      cursor: pointer;

      &:hover {
        background: $landing-bg-light;
        color: $landing-primary-color;
      }

      i {
        width: 24px;
        text-align: center;
        color: $landing-primary-color;
      }
    }

    .mobile-left-drawer-phone {
      font-size: 1.2rem;
      border-bottom: 1px solid $landing-border-light;
      margin-bottom: 0.5rem;
    }

    .navbar-collapse {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background: $landing-bg-white;
      box-shadow: 0 8px 20px $landing-primary-rgba-15;
      padding: 1rem 0;
      max-height: calc(100vh - 120px);
      overflow-y: auto;
      transition: opacity 0.3s ease;
    }

    .navbar-collapse:not(.show) {
      display: none !important;
    }

    .navbar-collapse.show {
      display: block !important;
    }

    .navbar-toggler {
      border: 2px solid rgba(0, 0, 0, 0.15);
      padding: 0.5rem 0.75rem;
      border-radius: 8px;
    }

    .navbar-nav {
      margin-top: 0.5rem;
      text-align: center;

      .nav-link,
      .dropdown-toggle {
        min-height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        -webkit-tap-highlight-color: transparent;
      }

      .dropdown .dropdown-item {
        min-height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.85rem 1.5rem;
      }
      
      .dropdown {
        .dropdown-menu {
          position: static !important;
          float: none;
          width: 100%;
          margin-top: 0.5rem;
          box-shadow: none;
          border: 1px solid $landing-border-light;
          border-radius: 8px;
        }
      }
    }
    
    .navbar-actions {
      justify-content: center;
      margin-top: 1rem;
      flex-wrap: wrap;
      padding-top: 1rem;
      border-top: 1px solid $landing-border-light;
    }
  }
  
  @media (max-width: 768px) {
    .navbar {
      padding: 1.25rem 0;
      
      .brand-content .logo-img {
        height: 55px;
      }
      
      .navbar-nav .nav-link {
        font-size: 1.2rem;
        padding: 0.75rem 1.25rem;
      }
      
      .navbar-actions {
        gap: 15px;
        
        .btn-member {
          font-size: 1.15rem;
          padding: 14px 28px;
          
          i {
            font-size: 1.15rem;
          }
        }
      }
    }
  }
}
</style>
